;(function () {
  'use strict'

  angular
    .module('contrast.service.keys.management')
    .factory('keysManagementService', keysManagementService)

  function keysManagementService(UserFactory, ServiceUtils) {
    'ngInject'

    var service = {
      getAgentKeys: getAgentKeys,
      getApiKey: getApiKey,
      rotateAPIKey: rotateAPIKey,
      rotateAgentServiceKey: rotateAgentServiceKey
    }

    return service

    function getAgentKeys() {
      return UserFactory.getAgentKeys()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getApiKey() {
      return UserFactory.getApiKey()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function rotateAPIKey() {
      return UserFactory.rotateAPIKey()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function rotateAgentServiceKey() {
      return UserFactory.rotateAgentServiceKey()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }
  }
})()
